'use memo';

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';

import VStack from '@/components/Layout/VStack';

import { OutboundDetailHeader } from './-layout/OutboundDetailHeader';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail',
)({
  component: Layout,
});

/** OUT 詳細レイアウト。IN _pipeline-detail と同型: 詳細ヘッダ(Breadcrumb + Body + Tabs)のみ。最上位 ProductHeader は出さない。 */
function Layout() {
  return (
    <VStack>
      <Suspense>
        <OutboundDetailHeader />
      </Suspense>
      <Outlet />
    </VStack>
  );
}
